/* eslint-disable no-unused-vars */
import axios from "../http-client/axios";
import { SCORPIONS_URL } from "../urls/base-urls";

// eslint-disable-next-line no-unused-vars
export async function getCrms(crm) {
  let query = ``;
  if(crm)
    query += `?crm=${crm}`
  const resp = await axios({
    url: `${SCORPIONS_URL}/admin/crms${query}`,
    method: "get",
    data: {},
    headers: { "content-type": "application/json" },
  });
 
  return resp.data;
}

export default getCrms;
